import type { EligibleSlug } from '../constants'
import { aiFundamentalsContent } from './courses/ai-fundamentals-think-create-and-work-smarter'
import { moonshotsContent } from './courses/breakthrough-innovation-strategy-from-bold-idea-to-business-impact'
import { leadWithAiContent } from './courses/lead-with-ai-adapt-implement-transform-your-organization'
import { navySealsContent } from './courses/leadership-and-decision-making-under-pressure'
import { negotiateToWinContent } from './courses/negotiate-to-win-essentials-for-leaders'
import { strategicCommunicationContent } from './courses/strategic-communication-build-trust-drive-decisions-lead-with-influence'
import type { CourseQuizContent } from './types'

const registry: Record<EligibleSlug, CourseQuizContent> = {
  'ai-fundamentals-think-create-and-work-smarter': aiFundamentalsContent,
  'lead-with-ai-adapt-implement-transform-your-organization': leadWithAiContent,
  'leadership-and-decision-making-under-pressure': navySealsContent,
  'negotiate-to-win-essentials-for-leaders': negotiateToWinContent,
  'strategic-communication-build-trust-drive-decisions-lead-with-influence':
    strategicCommunicationContent,
  'breakthrough-innovation-strategy-from-bold-idea-to-business-impact':
    moonshotsContent,
}

export const getCourseContent = (slug: string): CourseQuizContent | null =>
  registry[slug as EligibleSlug] ?? null
